export const ONE_SIGNAL_APP_ID = 'f220bde0-51e4-403c-8f33-0411a8cfc585';
export const GOOGLE_TAG_MANAGER_ID = 'G-5EGCELSDYB';

// Font Families
export const DEFAULT_FONT_FAMILY = 'Stag Sans LC';
export const DEFAULT_FONT_FAMILY_SEMIBOLD = 'Stag Sans LC Semibold';
